import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Routes from './routes';

import GlobalStyle from './styles/global';

function App() {
    return (
        <BrowserRouter>
            <GlobalStyle />
            <Routes />
            <ToastContainer
                autoClose={3000}
                className="toast-container"
                toastClassName="toast"
            />
        </BrowserRouter>
    );
}

export default App;
